import { checkPromotionCodeV2 } from "src/service/pay";
import { notifyError } from "src/components/Common/Toast";
import { maxLengthValidation } from "src/utils/validation";
import ToggleAskPromotion from "./_ToggleAskPromotion";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  ICheckPromotionCodeRes,
  ICreateServiceBillReq,
} from "src/service/types/pay.type";
import RightDetailBox from "./_RightDetailBox";
import dayjs from "dayjs";
import { dateFormatUtcToYMD1 } from "src/utils/dateManagement";
import { SubmitHandler } from "react-hook-form";
import { useCommonForm } from "src/hooks/useCommonForm";
import { ProductKey } from "src/config/config";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import styles from "./SitePromotion.module.scss";
import { useTranslation } from "react-i18next";

interface ICheckPromotionProps {
  toggleAskPromotionOn: boolean;
  setToggleAskPromotionOn: Dispatch<SetStateAction<boolean>>;
  promotionCode: string;
  setPromotionCode: Dispatch<SetStateAction<string>>;
  isCheckPromotionCode: string;
  setIsCheckPromotionCode: Dispatch<SetStateAction<string>>;
  promotionApply: ({
    issueAppList,
    referralId,
    promotionCode,
  }: {
    issueAppList: string[];
    referralId: string;
    promotionCode: string;
  }) => void;
}
const CheckPromotion = ({
  toggleAskPromotionOn,
  setToggleAskPromotionOn,
  promotionCode,
  setPromotionCode,
  isCheckPromotionCode,
  setIsCheckPromotionCode,
  promotionApply,
}: ICheckPromotionProps) => {
  const [isPromotionCode, setIsPromotionCode] = useState(false);
  const [checkPromotionCodeV2Res, setCheckPromotionCodeV2] =
    useState<ICheckPromotionCodeRes>();
  const { register, setValue, getValues, formState, handleSubmit } =
    useCommonForm();
  const { t } = useTranslation();
  const promotionCodeCheck = async () => {
    // alert가 아닌 상태값 변경을 처리해서 뒤로 넘김
    if (promotionCode === "") {
      notifyError(t("siteType.premium.detail.plan.invalidPromotionCode"));
      // setIsCheckPromotionCode("FAIL");
      setIsPromotionCode(false);
      return;
    }

    const promotionCodeLength = maxLengthValidation(promotionCode, 44);

    if (!promotionCodeLength) {
      notifyError(t("common.alert.overPromotionCode"));
      return;
    }

    await checkPromotionCodeV2({
      promotionCode,
      product: sessionStorage.getItem("product") as ProductKey,
    })
      .then((result) => {
        const { nxacAppList, drmPackageInfo } = result;
        // console.log("result", result);
        // console.log("promotionCode", promotionCode);
        setIsCheckPromotionCode("OK");
        if (nxacAppList && nxacAppList.length > 0) {
          const issueAppList = nxacAppList?.map((app) => {
            return app.id;
          });
          setValue("issueAppList", issueAppList);
        }
        // DSF 구독 정보 세팅
        if (drmPackageInfo) {
          setValue("packageName", drmPackageInfo?.packageName);
          setValue("products", drmPackageInfo?.products);
        }
        // setPromotionDayView(result?.promotionDay);
        // setValidityTimeView(result?.validityTime);
        // setLicenseCountView(result?.licenseCount);
        // setExternalLicenseCountView(result?.externalLicenseCount);
        // setUserPerStorageView(result?.userPerStorage);
        setCheckPromotionCodeV2(result);
        setIsPromotionCode(true);
      })
      .catch((error: any) => {
        console.log("error", error);
        setIsPromotionCode(false);
        setIsCheckPromotionCode("FAIL");
        if (error?.errorCode === "OVER_VALIDITY_TIME") {
          setToggleAskPromotionOn((prev) => !prev);
        }
      });
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.name === "promotionCode") {
      // console.log("e.target.value", e.target.value);
      if (maxLengthValidation(e.target.value, 44)) {
        setIsPromotionCode(true);
        setPromotionCode(e.target.value);
        // state[e.target.name] = e.target.value
      } else {
        setPromotionCode(e.target.value);
        // state[e.target.name] = e.target.value.substr(0, 44)
      }
    }
  };
  const onSubmit: SubmitHandler<ICreateServiceBillReq> = (e: any) => {
    // console.log("onsubmit", e);
    const { issueAppList, referralId } = e;
    // e.preventDefault();
    promotionApply({ issueAppList: issueAppList, referralId, promotionCode });
  };
  // useEffect(() => {
  //   console.log("isCheckPromotionCode", isCheckPromotionCode);
  // }, [isCheckPromotionCode]);
  return (
    <form className="form" onSubmit={handleSubmit(onSubmit)}>
      <div className="flex justify-space-between">
        <div className="flex-item box box__lt bg-white">
          <h4 className="form-title">
            {t("siteType.premium.detail.plan.title")}
          </h4>
          <div className="form-item">
            <ToggleAskPromotion
              toggleAskPromotionOn={toggleAskPromotionOn}
              setToggleAskPromotionOn={setToggleAskPromotionOn}
            />
            <div className="flex align-bottom">
              <div className="width w-320 ">
                <input
                  type="text"
                  {...register("promotionCode")}
                  // id="promotionCode"
                  // name="promotionCode"
                  value={promotionCode}
                  onChange={handleChange}
                  maxLength={60}
                  className={`form-control custom-form 
                        ${
                          isCheckPromotionCode === "OK"
                            ? "form-item-textbox-valid"
                            : isCheckPromotionCode === "FAIL"
                            ? "form-item-textbox-invalid"
                            : ""
                        }`}
                />
              </div>
              <div className="pd pl-20">
                <button
                  type="button"
                  onClick={promotionCodeCheck}
                  disabled={!isPromotionCode}
                  className="btn btn-green buttonH40"
                >
                  {t("siteType.premium.detail.plan.registerBtn")}
                </button>
              </div>
            </div>
          </div>
          {checkPromotionCodeV2Res && (
            <div
              className={`${
                isCheckPromotionCode === "OK" ? "display-block" : "display-none"
              } mg mt--20`}
            >
              <span className="text text--green">
                {t("siteType.premium.detail.plan.validPromotionCode")}
              </span>
              <div className="inBox">
                {/* // 쿠폰 유효기간 주석처리
      <span className="form-item-title">
        {t(
          'siteType.premium.detail.plan.availablePeriods'
        )}
      </span>
      <div className="text text--black mg mb-16">
        {dateFormatUtc(validityTimeView)}
        {t(
          'siteType.premium.detail.plan.until'
        )}
      </div>
       */}
                {/* 구독 종료일 */}
                <span className="form-item-title">
                  {t("siteType.premium.detail.plan.expirationDate")}
                </span>
                <div className="text text--black mg mb-16">
                  {checkPromotionCodeV2Res.subscriptionEndDate ? (
                    <>
                      {dateFormatUtcToYMD1(
                        checkPromotionCodeV2Res.subscriptionEndDate
                      )}
                      (
                      {t("siteType.premium.detail.plan.days", {
                        0: dayjs(
                          checkPromotionCodeV2Res.subscriptionEndDate
                        ).diff(dayjs(), "days"),
                      })}
                      )
                    </>
                  ) : (
                    // t(
                    //     "siteType.premium.detail.plan.days",
                    //     checkPromotionCodeV2Res.subscriptionEndDate
                    //   )
                    "-"
                  )}
                </div>
                {/* 사용 가능 인원 */}
                <span className="form-item-title">
                  {t("siteType.premium.detail.plan.userNum")}
                </span>
                <div className="text text--black mg mb-16">
                  {t("siteType.premium.detail.plan.person", {
                    0: checkPromotionCodeV2Res.licenseCount,
                  })}
                </div>
                {/* 외부 사용자수 */}
                {window.sessionStorage.getItem("product") ===
                  "WRAPSODY_ECO" && (
                  <span className="form-item-title">
                    {t("siteType.premium.detail.plan.userExtenalInvite")}
                  </span>
                )}
                {window.sessionStorage.getItem("product") ===
                  "WRAPSODY_ECO" && (
                  <div className="text text--black mg mb-16">
                    {t("siteType.premium.detail.plan.person", {
                      0: checkPromotionCodeV2Res.externalLicenseCount,
                    })}
                  </div>
                )}
                {/* 용량 */}
                {getProductFromSessionStorage() !== "DSP" && (
                  <>
                    <span className="form-item-title">
                      {t("siteManagement.createSite.detail.storage.fieldname")}(
                      {t("siteManagement.createSite.detail.storage.byteUnit")})
                    </span>
                    <div className="text text--black mg mb-16">
                      {checkPromotionCodeV2Res.totalStorage}
                    </div>
                  </>
                )}
                {/* 금액 (2026-01-20 주석처리)*/}
                {/* <span className="form-item-title">
                  {t("cashStatus.pay.totalPrice")}
                </span>
                <div className="text text--black mg mb-16">
                  {checkPromotionCodeV2Res?.totalPrice}
                </div> */}
                {/* 등록 애플리케이션 */}
                {checkPromotionCodeV2Res?.nxacAppList?.length > 0 && (
                  <>
                    <span className="form-item-title">
                      {t("common.application")}
                    </span>
                    <div className="text text--black mg mb-16">
                      {checkPromotionCodeV2Res?.nxacAppList?.map(
                        (app, index) => {
                          return (
                            <span key={index}>
                              {index !== 0 && ", "}
                              {app.name}
                            </span>
                          );
                        }
                      )}
                    </div>
                  </>
                )}
                {/* 추천인 */}
                {checkPromotionCodeV2Res?.referralId && (
                  <>
                    <span className="form-item-title">
                      {t("siteType.referralId")}
                    </span>
                    <div className="text text--black mg mb-16">
                      {/* {checkPromotionCodeV2Res.referralId ?? "없음"} */}
                      <input
                        type="text"
                        // id="userName"
                        // name="userName"
                        {...register("referralId")}
                        // title={t("siteType.free.detail.username")}
                        value={checkPromotionCodeV2Res?.referralId}
                      />
                    </div>
                  </>
                )}
                {checkPromotionCodeV2Res?.drmPackageInfo && (
                  <>
                    <span className="form-item-title">
                      {/* {t("siteType.referralId")} */}
                      Drm Package
                    </span>
                    <div className="text text--black mg mb-16">
                      {
                        checkPromotionCodeV2Res?.drmPackageInfo
                          ?.packageDescription
                      }
                      (
                      {checkPromotionCodeV2Res?.drmPackageInfo?.products?.map(
                        (product, index) => {
                          return (
                            <span key={index}>
                              {index !== 0 && ", "}
                              {product}
                            </span>
                          );
                        }
                      )}
                      )
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
          <div>
            <div
              className={`${
                isCheckPromotionCode === "FAIL"
                  ? "display-block"
                  : "display-none"
              } mg mt--20`}
            >
              <span className="text text--orange">
                {t("siteType.premium.detail.plan.invalidPromotionCode")}
              </span>
            </div>
          </div>
        </div>

        {/* {getProductFromSessionStorage() !== "ENTERPRISE_DRM" && ( */}
        <RightDetailBox
          toggleAskPromotionOn={toggleAskPromotionOn}
          isCheckPromotionCode={isCheckPromotionCode}
        />
        {/* )} */}
      </div>
    </form>
  );
};

export default CheckPromotion;
